<template>
  <div
    class="w-2/12 mt-2 md:flex items-center hidden"
    v-for="(audio, indexo) in audios.slice(index, index + 1)"
    :key="indexo"
  >
    <div class="flex flex-col mr-6 items-center font-semibold">
      <p class="text-gray-400">{{ artist ? artist.name_ar:audio.artist.name_ar }}</p>
      <p class="text-xs text-gray-200">{{ audio.name_ar }}</p>
    </div>
    <img class="w-16 h-16 rounded-full mt-2 " :src="getImage(artist,audio)" :alt="audio.name_ar" width="100" height="100" />
  </div>
</template>

<script>
export default {
  props: ["audios", "artist", "index"],
  data() {
    return {
      https: "https://systech-abrof.s3.amazonaws.com/artists/",
    };
  },
  methods: {
    getImage(artist,audio) {
      var images;
      if(audio&& audio.cover_full_url){
        return  audio.cover_full_url;
      }else
      if(audio&& audio.artist&&audio.artist.cover){
        return this.https + audio.artist.cover;
     
      }else if (artist.cover) {
        return this.https + artist.cover;
      } else {
         images = require.context("@/assets/logo", false, /\.svg$/);
        return images("./" + "main.svg");
      }
    },
  },
};
</script>

<style>
</style>